<template>
  <div id="app">

    <!-- <Header title="title"></Header> -->

    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/Header'

export default {
  name: 'App',
  props: ['title'],
  components: {
    Header
  },
  data() {
    return {
      isActive: false,
      title: this.title
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    }
  },
}
</script>

<style lang="css">

  html, body {
    font-family: "Averta", "Arial", "sans-serif" !important;
  }

</style>
